/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CeaInfindCeasByCta from './CeaInfindCeasByCta';
import CpaInfindCeasByCta from './CpaInfindCeasByCta';

/**
 * The ItemOfFindCeasByCtaRequest model module.
 * @module model/ItemOfFindCeasByCtaRequest
 * @version 2.8.0
 */
class ItemOfFindCeasByCtaRequest {
    /**
     * Constructs a new <code>ItemOfFindCeasByCtaRequest</code>.
     * @alias module:model/ItemOfFindCeasByCtaRequest
     * @param cpa {module:model/CpaInfindCeasByCta} 
     */
    constructor(cpa) { 
        
        ItemOfFindCeasByCtaRequest.initialize(this, cpa);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, cpa) { 
        obj['cpa'] = cpa;
    }

    /**
     * Constructs a <code>ItemOfFindCeasByCtaRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ItemOfFindCeasByCtaRequest} obj Optional instance to populate.
     * @return {module:model/ItemOfFindCeasByCtaRequest} The populated <code>ItemOfFindCeasByCtaRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ItemOfFindCeasByCtaRequest();

            if (data.hasOwnProperty('cpa')) {
                obj['cpa'] = CpaInfindCeasByCta.constructFromObject(data['cpa']);
            }
            if (data.hasOwnProperty('headCea')) {
                obj['headCea'] = CeaInfindCeasByCta.constructFromObject(data['headCea']);
            }
            if (data.hasOwnProperty('tailCea')) {
                obj['tailCea'] = CeaInfindCeasByCta.constructFromObject(data['tailCea']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/CpaInfindCeasByCta} cpa
 */
ItemOfFindCeasByCtaRequest.prototype['cpa'] = undefined;

/**
 * @member {module:model/CeaInfindCeasByCta} headCea
 */
ItemOfFindCeasByCtaRequest.prototype['headCea'] = undefined;

/**
 * @member {module:model/CeaInfindCeasByCta} tailCea
 */
ItemOfFindCeasByCtaRequest.prototype['tailCea'] = undefined;






export default ItemOfFindCeasByCtaRequest;

